import {Button} from "./Button";
import {MovieMold} from "../library/MovieMold";
import {LibraryFlump} from "../library/LibraryFlump";

export class ClickArea extends Button {

  constructor(mold: MovieMold, library: LibraryFlump) {
    super(mold, library);
  }

  // override  getShimmerPixelMaskObject():DisplayObject {
  //   return _btnContent;
  // }

  override build() {
    super.build();
    this.clicksBetweenDelay = 0.5;
    this.interactive = true;
    this._btnContent!.alpha = 0;
  }

  override onTouch() {
  }
  override onUnTouch() {
  }
}
